export const selectorTypes = {
	checkbox: 'checkbox',
	radio: 'radio'
};

export const keys = {
	locations: 'locations',
	trafficSources: 'trafficSources',
	niches: 'niches',
	experience: 'experience'
};

export const questions = [
	{
		key: keys.locations,
		title: 'С какими ГЕО Вы хотите работать?',
		selectorType: selectorTypes.checkbox,
		optionsSelector: 'targetingLocations'
	},
	{
		key: keys.trafficSources,
		title: 'С какими источниками трафика Вы работаете?',
		selectorType: selectorTypes.checkbox,
		optionsSelector: 'trafficSources'
	},
	{
		key: keys.niches,
		title: 'С какими нишами Вы бы хотели работать?',
		selectorType: selectorTypes.checkbox,
		optionsSelector: 'niches'
	},
	{
		key: keys.experience,
		title: 'Ваш опыт работы с трафиком?',
		selectorType: selectorTypes.radio,
		options: [
			{ text: 'Только начинаю', id: 'Just starting' },
			{ text: 'Меньше года', id: 'Less than a year' },
			{ text: '1-2 года', id: '1-2 years' },
			{ text: '3-4 года', id: '3-4 years' },
			{ text: '5+ лет', id: '5+ years' }
		]
	}
];


// WEBPACK FOOTER //
// ./frontend/cabinets/apps/everad/modules/survey/enums.js